/**
 * PATH: packages/email-hub/src/feature/pages/inbox-page/InboxAnalysisSurface.tsx
 * FILE_ID: EMAIL-INBOX-ANALYSIS-SURFACE-001
 * PURPOSE: Render Phase C intelligence workspace (analysis + copilot).
 */

import { Sparkles } from 'lucide-react'
import IntelligenceWorkspace from '../../components/IntelligenceWorkspace'
import type { InboxPageController } from './useInboxPageController'

export function InboxAnalysisSurface({ vm }: { vm: InboxPageController }) {
  const {
    kanbanApi,
    kanbanOrgId,
    rightTab,
    copilotSeed,
    setAiLinkOpen,
    refetch,
    refetchStats,
    selectedEmail,
  } = vm
  return (
    <>
        {rightTab === 'ai' && (
          <div className="flex-1 min-h-0 overflow-y-auto p-3">
            {selectedEmail ? (
              <IntelligenceWorkspace
                email={selectedEmail}
                autoAnalyze
                onActionClick={(action: string, _payload?: Record<string, unknown>) => {
                  if (action === 'link_job' || action === 'create_job') setAiLinkOpen(true)
                }}
                api={kanbanApi}
                orgId={kanbanOrgId}
                copilotSeed={copilotSeed?.text}
                copilotSeedNonce={copilotSeed?.nonce}
                onApplied={() => { refetch(); refetchStats() }}
              />
            ) : (
              <div className="h-full flex flex-col items-center justify-center text-center text-muted-foreground/60 px-6">
                <Sparkles className="h-8 w-8 mb-2 opacity-30" />
                <p className="text-sm font-medium">Select an email to analyse</p>
                <p className="text-xs mt-1">The AI co-pilot reads the open email and suggests next actions.</p>
              </div>
            )}
          </div>
        )}

    </>
  )
}
